import { products } from "../endpoints/products.endpoints";
import $axios from "../http/accessor";

const OrderService = {
  getUserOrders: () => {
    return $axios.get(products.my_orders);
  },
};

export default OrderService;
